import NormalIcon from '../StockItems/NormalIcon';

function App(props) {

  var addToExtraScreen = props.addToExtraScreen;
  var set = props.set;
  var skipWrap = props.skipWrap;


    function clickGuide(e){
      addToExtraScreen({t:'guideScreen', set});
    }
    var ii = <NormalIcon icon='carbon:help' onClick={clickGuide} title='Guide'/>;
    if (skipWrap){
      return ii;
    }

//

   return <div style={{textAlign:'right'}}>{ii}</div>


}
//
export default App;
